module.exports = "/images/vendor/flag-icon-css/flags/4x3/bn.svg?1d4e60918c474f844110c46d560233b8";